<mat-chip class="preferred-chip">
    <mat-icon class="custom-chip-icon" matChipAvatar>stars</mat-icon>
    <span>Preferred</span>
</mat-chip>
  